// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__7s6fq","buttons":"RemoveExpirationActionButtons_buttons__NhGxi"};